export default "__VITE_ASSET__4c1c91fa__"